import * as ActionType from "./post.type";

const initialState = {
  post: [],
};

export const postReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_POST:
      return {
        ...state,
        post: action.payload,
      };

    case ActionType.DELETE_POST:
      return {
        ...state,
        post: state.post.filter((post) => post._id !== action.payload),
      };

    case ActionType.UPDATE_POST:
      return {
        ...state,
        post: state.post.map((post) => {
          if (post._id === action.payload.id) {
            return {
              ...post,
              ...action.payload.data,
            };
          } else {
            return post;
          }
        }),
      };

    default:
      return state;
  }
};
